import "core-js/modules/es.array.push.js";
export default {
  data() {
    return {
      logoList: [{
        logos: [],
        classOption: {
          limitMoveNum: 15,
          direction: 2,
          hoverStop: false,
          step: 0.9
        }
      }, {
        logos: [],
        classOption: {
          limitMoveNum: 15,
          direction: 2,
          hoverStop: false,
          step: 0.8
        }
      }, {
        logos: [],
        classOption: {
          limitMoveNum: 14,
          direction: 2,
          hoverStop: false,
          step: 1
        }
      }]
    };
  },
  created() {
    this.getLogos();
  },
  methods: {
    getImagePath(imageName) {
      return require(`../../assets/images/partner/${imageName}`);
    },
    getLogos() {
      for (let i = 1; i <= 44; i++) {
        if (i <= 15) {
          this.logoList[0].logos.push({
            id: i,
            src: `p-${i}.jpg`
          });
        } else if (i <= 30 && i > 15) {
          this.logoList[1].logos.push({
            id: i,
            src: `p-${i}.jpg`
          });
        } else if (i <= 44 && i > 30) {
          this.logoList[2].logos.push({
            id: i,
            src: `p-${i}.jpg`
          });
        }
      }
    }
  }
};